import * as yup from 'yup'
import { i18WithDefault as t } from '../shared'
import YupPassword from 'yup-password'

YupPassword(yup)

export const signUpSchema = yup.object({
  email: yup.string().email(t('password.email.error')).required(t('password.emailRequired.error')),
  password: yup
    .string()
    .min(8, t('password.minLength.error'))
    .max(200, t('password.requirements.error'))
    .minNumbers(1, t('password.requirements.error'))
    .minSymbols(1, t('password.requirements.error'))
    .required(t('password.required.error')),
  password_confirmation: yup
    .string()
    .label(t('signUpForm.passwordConfirmation'))
    .oneOf([yup.ref('password'), null], t('password.mustMatch'))
    .required(t('password_confirmation.requirements.error')),
})

export const initialValues = () => {
  return {
    email: '',
    password: '',
    password_confirmation: '',
  }
}
